<template>
  <div class="login-card__birthday">
    <div class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.birthday.header') }}</h1>
      <p class="login-card__title-desc"> {{ trans.get('auth.card.birthday.subheader') }}</p>
    </div>
    <div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <InputDate v-model="form.birth_date"></InputDate>
          <button type="submit" class="button button__fill button--w-100 mt-4 mb-3 text--smedium">{{ trans.get('auth.card.birthday.continue') }}</button>
        </form>
      </validation-observer>

      <a v-if="!form.isLoggedId" :href="zRoute('login.provider', 'facebook')" class="button button__link button__link--blue p-1"><i class="demo-icon icon-facebook pr-2"></i>{{ trans.get('auth.card.login.facebook') }}</a>
      <a v-if="!form.isLoggedId" :href="zRoute('login.provider', 'google')" class="button button__link button__link--google p-1"><img class="logo-google" src="/img/viluu/logo/google-logo.svg" alt="Logo google">{{ trans.get('auth.card.welcome.google_button') }}</a>
      <a v-if="!form.isLoggedId" :href="zRoute('login.provider', 'apple')" class="button button__link button__link--apple p-1"><img class="logo-apple" src="/img/viluu/logo/apple-logo.svg" alt="Logo apple">{{ trans.get('auth.card.welcome.apple_button') }}</a>

      <button type="button" class="button button__link button__link--underline text--smedium" @click="goBack">{{ trans.get('auth.card.buttons.back') }}</button>
    </div>
  </div>
</template>
<script>
import InputDate from './InputDate';
import AuthGoBackMixin from '../../../front/components/Auth/AuthGoBackMixin';

export default {
  mixins: [AuthGoBackMixin],
  props: ['swapComponent', 'form'],
  components: {
    InputDate,
  },
  methods: {
    onSubmit() {
      this.swapComponent('auth-location-card');
    },
    goBack() {
      axios
        .post(zRoute('logout'))
        .then(() => {
          this.$emit('reset-form');
          this.swapComponent('auth-welcome-card');
        });
    }
  },
  activated() {
    this.$refs.form.reset();
    this.$emit('update:progress', 20);
    this.$emit('update:step', 1);
  }
};
</script>
<style scoped>
</style>
